let instance = null;

export default class AppBlobCache
{
  constructor()
  {
    if (!instance) {
      instance = this;
    }

    instance.blobs = instance.blobs || {};
    return instance;
  }

  getContentUrl(contentUrl)
  {
    return fetch(contentUrl);
  }


  getMediaBlobs()
  {
    return this.blobs;
  }

  getMediaBlobByKey(key)
  {
    for (var k in this.blobs)
    {
      if (k === key)
      {
        if (this.blobs[k].blob_url)
        {
          console.log("BLOB URL FOUND! " + this.blobs[k].blob_url)
          return this.blobs[k].blob_url;
        }
        else
        {
          console.log("warning: RAW URL FOUND! " + this.blobs[k].url)
          return this.blobs[k].url;
        }
      }
    }
    console.log("error: NO KEY FOUND! " + key)
    return null;
  }

  putMediaBlobByKey(key, mediaBlob)
  {
    this.blobs[key] = mediaBlob;
  }


  preloadMediaListUrl(mediaListUrl)
  {
    return fetch(mediaListUrl)
        .then((res) => {
          //debugger;
          return res.json()
        })
        .then((res) => {

          return new Promise((resolve, reject) => {

            var raw_mediaList = res || {};
            var mediaList = [];
            for (var k in raw_mediaList)
            {
              var raw_media = raw_mediaList[k];
              for (var m in raw_media)
              {
                var filename = m;
                if (raw_media[filename] && raw_media[filename].url)
                {
                  // video or sound
                  if (raw_media[filename].url.substr(raw_media[filename].url.length - 4) === '.mp4')
                  {
                    // video
                    mediaList.push({
                      type: 'video',
                      ext: 'mp4',
                      filename: filename,
                      url: raw_media[filename].url,
                    })
                  }
                  else
                  {
                    // sound
                    mediaList.push({
                      type: 'sound',
                      ext: 'mp3',
                      filename: filename,
                      url: raw_media[filename].url,
                    })
                  }
                }
                else if (raw_media[filename] && raw_media[filename].large && raw_media[filename].thumbnail)
                {
                  // image
                  mediaList.push({
                    type: 'image',
                    ext: 'jpg',
                    filename: filename,
                    url: raw_media[filename].large.url,
                  })
                }
              }
            }
            //debugger;

            this.recursivelyDownloadMedia(mediaList, 0, (cursor) => {
              //debugger;
              resolve({
                result: true,
                cursor: cursor,
              });
            })

          })
        })
        .catch((e) => {
          return {result: false, error: e};
        })
  }



  recursivelyDownloadMedia(mediaList, cursor, callback)
  {
    console.log(mediaList);
    var media = mediaList[cursor];
    var _path = '/media/' + media.type + '/' + media.filename + '.' + media.ext;
    console.log(_path);
    console.log('url', media.url);

    var mediaBlob = Object.assign({}, media);

    var isExists = this.getMediaBlobByKey(_path);
    if (isExists)
    {
      cursor += 1;
      if (cursor < mediaList.length)
      {
        this.recursivelyDownloadMedia(mediaList, cursor, callback);
      }
      else
      {
        callback(cursor);
      }
      return;
    }
    else
    {
      var self = this;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', media.url, true);
      xhr.responseType = 'blob';
      xhr.onload = function(e)
      {
        if (this.status == 200)
        {
          var blob = this.response;
          var blob_url = window.URL.createObjectURL(blob);
          mediaBlob.blob_url = blob_url;
        }
        else
        {
          mediaBlob.blob_url = null;
        }

        self.putMediaBlobByKey(_path, mediaBlob);

        cursor += 1;
        if (cursor < mediaList.length)
        {
          self.recursivelyDownloadMedia(mediaList, cursor, callback);
        }
        else
        {
          callback(cursor);
        }

      };
      xhr.send();
    }
  }
}
